import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

export default function ContactSuccessStep({ onReset }) {
  return (
    <motion.div
      key="success-step"
      initial={{ opacity: 0, scale: 0.96 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.96 }}
      transition={{ duration: 0.4 }}
      className="text-center py-8"
      data-testid="contact-success"
    >
      <div className="mx-auto w-14 h-14 rounded-full border border-blue-500/40 bg-blue-500/10 flex items-center justify-center mb-5">
        <CheckCircle2 className="w-6 h-6 text-blue-400" />
      </div>
      <h4 className="font-display text-2xl font-medium tracking-tight">Message delivered</h4>
      <p className="mt-3 text-zinc-400 text-sm max-w-md mx-auto">
        Thanks for reaching out — we received your verified inquiry and will reply within 1–2 business days.
      </p>
      <button
        onClick={onReset}
        data-testid="contact-reset-button"
        className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/15 text-white text-sm hover:bg-white/5 transition-colors"
      >
        Send another message
      </button>
    </motion.div>
  );
}
